import './style';
import App from './components/app';
import startMockServer from './server';

startMockServer();

export default App;
